const styles = () => ({
  infoCard: {
    marginTop: '2%',
    marginBottom: '15%',
    marginLeft: '10%',
    marginRight: '5%',
    padding: '2%',
    maxWidth: '1000px',
    position: 'absolute',
    zIndex: 1,
    backgroundColor: 'rgba(45, 45, 45, .8)',
    borderRadius: '5px',
    fontSize: '18px',
    color: 'white',
  },
  info: {
    margin: '0 10%',
    padding: '550px 10px 50px 10px',
  },
  button: {
    backgroundColor: 'rgba(255, 255, 255, .6)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, .4)',
    },
  },
})

export default styles
